import * as fromDatatype from "../datatype-library/index";

export interface bl_del_region_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    region_code: fromDatatype.VarcharDatatypeInterface;
    region: fromDatatype.VarcharDatatypeInterface;
    country: fromDatatype.VarcharDatatypeInterface;
    state: fromDatatype.VarcharDatatypeInterface;
    google_location_name: fromDatatype.VarcharDatatypeInterface;
    google_location_url: fromDatatype.VarcharDatatypeInterface;
    geofencing_json: fromDatatype.JsonDatatypeInterface;
    level_value: fromDatatype.IntegerDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    label_list_guid: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_del_region_hdr_RowClass implements bl_del_region_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    region_code: fromDatatype.VarcharDatatypeInterface;
    region: fromDatatype.VarcharDatatypeInterface;
    country: fromDatatype.VarcharDatatypeInterface;
    state: fromDatatype.VarcharDatatypeInterface;
    google_location_name: fromDatatype.VarcharDatatypeInterface;
    google_location_url: fromDatatype.VarcharDatatypeInterface;
    geofencing_json: fromDatatype.JsonDatatypeInterface;
    level_value: fromDatatype.IntegerDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    label_list_guid: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;
}
